export type Product = {
  id: string;
  revision?: number;
  sku: string;
  title: string;
  status: string;
  stage?: string | null;
  shipment_code?: string | null;
  arrival_date?: string | null;
  telegram_price?: number | null;
  updated_at?: string | null;
  has_photos?: boolean;
  settlement_status?: string | null;
  finance?: { purchase_cost?: number | null; delivery?: number | null };
};
export type AppState = {
  products: Product[];
  shipments?: Shipment[];
  can_finance: boolean;
  user_id?: number;
  bot_username?: string;
  can_publish?: boolean;
  is_owner?: boolean;
  role: string;
  name: string;
  timezone?: string;
};
export type Shipment = {
  code: string;
  arrival_date?: string;
  delivery_per_item?: number;
  status?: string;
  revision?: number;
  items?: unknown[];
};
export type CommerceState = {
  purchases?: Record<string, unknown>[];
  shipments?: Shipment[];
};
export type AccountingState = {
  accounts?: Record<string, unknown>[];
  documents?: Record<string, unknown>[];
  cycles?: Record<string, unknown>[];
};
const base = (import.meta.env.VITE_API_BASE || "/api").replace(/\/$/, "");
export class ApiError extends Error {
  constructor(
    message: string,
    public status: number,
  ) {
    super(message);
  }
}
export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const headers = new Headers(init?.headers);
  if (init?.method && !["GET", "HEAD"].includes(init.method.toUpperCase()))
    headers.set("X-Money-Schema", "3");
  if (init?.body && !(init.body instanceof FormData) && !headers.has("Content-Type"))
    headers.set("Content-Type", "application/json");
  const r = await fetch(`${base}/${path.replace(/^\//, "")}`, {
    ...init,
    headers,
    credentials: "include",
  });
  const type = r.headers.get("content-type") || "";
  const data: unknown = type.includes("json") ? await r.json() : await r.text();
  if (!r.ok) {
    if (r.status === 401 && !path.startsWith("auth/") && path !== "logout")
      window.dispatchEvent(new Event("estet:session-expired"));
    const msg =
      typeof data === "object" && data && "error" in data
        ? String((data as { error: unknown }).error)
        : typeof data === "string" && data.trim() && !data.trim().startsWith("<")
          ? data.slice(0, 1500)
          : `Ошибка запроса (${r.status})`;
    throw new ApiError(msg, r.status);
  }
  if (data && typeof data === "object" && "money_schema_version" in data && String(data.money_schema_version) !== "3")
    throw new ApiError("Формат денежных данных изменился. Обновите страницу.", 409);
  return data as T;
}
export const json = (value: unknown): RequestInit => ({
  method: "POST",
  body: JSON.stringify(value),
});
export async function authenticateMiniApp() {
  const initData = window.Telegram?.WebApp?.initData;
  if (!initData) return false;
  try {
    await api(
      "auth/telegram",
      json({
        initData,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC",
      }),
    );
    return true;
  } catch (e) {
    if (e instanceof ApiError && [404, 405].includes(e.status)) return false;
    throw e;
  }
}
